export default __webpack_public_path__ + "static/media/james_moseley_resume.0f0ce6ad.pdf";